export const permissions = localStorage.getItem("permissions") ? localStorage.getItem("permissions") : "";